// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-public',
  defaultApp: 'shah',
  apiUrl: 'https://wo7833gf46.execute-api.us-east-1.amazonaws.com/prod'
};
